/* home-JT.js – Schienen (Pfeile, Maus-Drag) und Reels-Player der Startseite (JT) */
(() => {
  if (window.__homeJT) return;
  window.__homeJT = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Schienen ---------- */
  function initRail(rail) {
    if (rail.dataset.jtReady) return;
    rail.dataset.jtReady = '1';
    const id = rail.id;
    const btns = id ? document.querySelectorAll('[data-jt-rail="' + id + '"]') : [];

    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth - 1;
      btns.forEach((b) => {
        b.disabled = Number(b.dataset.dir) < 0 ? rail.scrollLeft <= 1 : rail.scrollLeft >= max;
      });
    };

    btns.forEach((b) => b.addEventListener('click', () => {
      rail.scrollBy({ left: Number(b.dataset.dir) * rail.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' });
    }));
    rail.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(rail);

    /* Maus-Drag für Desktop ohne Trackpad */
    let dragged = false;
    rail.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      const startX = e.clientX;
      const startLeft = rail.scrollLeft;
      dragged = false;
      const move = (ev) => {
        const dx = ev.clientX - startX;
        if (!dragged && Math.abs(dx) > 5) { dragged = true; rail.classList.add('is-dragging'); }
        if (dragged) rail.scrollLeft = startLeft - dx;
      };
      const end = () => {
        rail.classList.remove('is-dragging');
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
      };
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', end);
    });
    rail.addEventListener('click', (e) => {
      if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; }
    }, true);
    rail.addEventListener('dragstart', (e) => e.preventDefault());
    update();
  }

  /* ---------- Reels ---------- */
  const ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  const ICON_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 5l-7 7 7 7"/></svg>';
  const ICON_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 5l7 7-7 7"/></svg>';

  function initReels(root) {
    if (root.dataset.jtReady) return;
    root.dataset.jtReady = '1';
    const cards = [...root.querySelectorAll('.jt-vid')];
    if (!cards.length) return;

    const load = (v) => {
      if (v.dataset.src && !v.src) { v.src = v.dataset.src; v.load(); }
    };

    cards.forEach((card) => {
      const v = card.querySelector('video');
      const bar = card.querySelector('.jt-vid__bar span');
      const mute = card.querySelector('.jt-vid__mute');
      if (!v) return;
      v.addEventListener('playing', () => card.classList.add('is-playing'));
      v.addEventListener('pause', () => card.classList.remove('is-playing'));
      v.addEventListener('timeupdate', () => {
        if (bar && v.duration) bar.style.width = (v.currentTime / v.duration) * 100 + '%';
      });
      if (mute) {
        mute.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const unmute = v.muted;
          cards.forEach((c) => {
            const o = c.querySelector('video');
            const m = c.querySelector('.jt-vid__mute');
            if (o) o.muted = true;
            if (m) { m.setAttribute('aria-pressed', 'false'); m.setAttribute('aria-label', 'Ton an'); }
          });
          v.muted = !unmute;
          mute.setAttribute('aria-pressed', String(unmute));
          mute.setAttribute('aria-label', unmute ? 'Ton aus' : 'Ton an');
          if (unmute) { load(v); v.play().catch(() => {}); }
        });
      }
    });

    /* Autoplay stumm, nur sichtbare Videos */
    if (!reduce && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target.querySelector('video');
          if (!v) return;
          if (en.isIntersecting && en.intersectionRatio >= 0.6) {
            load(v);
            v.play().catch(() => {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: [0, 0.6] });
      cards.forEach((c) => io.observe(c));
    }

    /* Vollbild-Player mit Ton */
    let dlg = null;
    let current = 0;
    const open = (i) => {
      if (!dlg) {
        dlg = document.createElement('dialog');
        dlg.className = 'jt jt-player';
        dlg.setAttribute('aria-label', 'Video');
        dlg.innerHTML = '<div class="jt-player__in"><video playsinline controls></video>'
          + '<button type="button" class="jt-player__btn jt-player__close" aria-label="Schließen">' + ICON_X + '</button>'
          + '<button type="button" class="jt-player__btn jt-player__prev" aria-label="Vorheriges Video">' + ICON_L + '</button>'
          + '<button type="button" class="jt-player__btn jt-player__next" aria-label="Nächstes Video">' + ICON_R + '</button>'
          + '<div class="jt-player__chip jt-vid__chip"></div></div>';
        document.body.appendChild(dlg);
        const pv = dlg.querySelector('video');
        dlg.querySelector('.jt-player__close').addEventListener('click', () => dlg.close());
        dlg.querySelector('.jt-player__prev').addEventListener('click', () => show(current - 1));
        dlg.querySelector('.jt-player__next').addEventListener('click', () => show(current + 1));
        pv.addEventListener('ended', () => show(current + 1));
        dlg.addEventListener('close', () => { pv.pause(); pv.removeAttribute('src'); pv.load(); });
        dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.classList.contains('jt-player__in')) dlg.close(); });
        let sx = 0;
        let sy = 0;
        dlg.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        dlg.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - sx;
          const dy = e.changedTouches[0].clientY - sy;
          if (Math.max(Math.abs(dx), Math.abs(dy)) < 50) return;
          const step = Math.abs(dx) > Math.abs(dy) ? (dx < 0 ? 1 : -1) : (dy < 0 ? 1 : -1);
          show(current + step);
        });
        dlg.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') { e.preventDefault(); dlg.close(); return; }
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') show(current + 1);
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') show(current - 1);
        });
      }
      cards.forEach((c) => { const v = c.querySelector('video'); if (v) v.pause(); });
      if (!dlg.open) dlg.showModal();
      show(i);
    };
    const show = (i) => {
      current = (i + cards.length) % cards.length;
      const card = cards[current];
      const pv = dlg.querySelector('video');
      pv.src = card.dataset.full || card.dataset.src || '';
      pv.poster = card.dataset.poster || '';
      pv.muted = false;
      pv.play().catch(() => { pv.muted = true; pv.play().catch(() => {}); });
      const chip = card.querySelector('.jt-vid__chip');
      dlg.querySelector('.jt-player__chip').innerHTML = chip ? chip.innerHTML : '';
      const link = dlg.querySelector('.jt-player__chip');
      if (chip && chip.href) { link.onclick = () => { window.location.href = chip.href; }; link.style.cursor = 'pointer'; }
    };

    cards.forEach((card, i) => {
      const fr = card.querySelector('.jt-vid__fr');
      if (fr) fr.addEventListener('click', (e) => {
        if (e.target.closest('.jt-vid__mute')) return;
        open(i);
      });
      if (fr) fr.addEventListener('keydown', (e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !e.target.closest('.jt-vid__mute')) { e.preventDefault(); open(i); }
      });
    });
  }

  const init = (scope) => {
    (scope || document).querySelectorAll('[data-jt-rail-track]').forEach(initRail);
    (scope || document).querySelectorAll('[data-jt-reels]').forEach(initReels);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  /* Theme-Editor: neu geladene Sections initialisieren */
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
